import HtmlRangeClient from "./HtmlRangeClient";

const API_ENDPOINT =
  process.env.HTML_RANGE_API ||
  "https://html-range-api.correctenglish-staging.com";
if (!API_ENDPOINT) {
  throw new Error(`Couldn't find API endpoint for HTML range API`);
}

const htmlRangeClient = new HtmlRangeClient(API_ENDPOINT);
export default htmlRangeClient;
